import React, { useState } from "react";
import ButtonComponent from "../../../components/commonComponent/ButtonComponent";

const KEY_INPUT_LABEL = "OpenRouter API key";

const CanvasAiKeyForm = ({ assistant, onCancel, onConnected }) => {
  const [apiKey, setApiKey] = useState("");
  const [isRemembered, setIsRemembered] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!apiKey.trim()) return;
    const isConnected = await assistant.connectCredential({
      apiKey,
      isRemembered,
    });
    if (isConnected) {
      setApiKey("");
      onConnected?.();
    }
  };

  const handleRemove = () => {
    assistant.removeCredential();
    setApiKey("");
  };

  return (
    <form className="canvas-ai-key-form" onSubmit={handleSubmit}>
      <div>
        <h3 className="canvas-ai-section-title">Connect OpenRouter</h3>
        <p className="canvas-ai-help-text">
          Your key is sent directly from this browser to OpenRouter. It is never
          saved with your Netpad note.
        </p>
      </div>
      <label className="canvas-ai-field-label" htmlFor="canvas-ai-api-key">
        {KEY_INPUT_LABEL}
      </label>
      <input
        autoComplete="off"
        className="canvas-ai-input"
        id="canvas-ai-api-key"
        onChange={(event) => setApiKey(event.target.value)}
        placeholder="sk-or-v1-…"
        type="password"
        value={apiKey}
      />
      <label className="canvas-ai-checkbox-row">
        <input
          checked={isRemembered}
          onChange={(event) => setIsRemembered(event.target.checked)}
          type="checkbox"
        />
        <span>Remember on this device</span>
      </label>
      {isRemembered && (
        <p className="canvas-ai-warning-text">
          Remembered keys are stored as plaintext in this browser.
        </p>
      )}
      <a
        className="canvas-ai-link"
        href="https://openrouter.ai/settings/keys"
        rel="noreferrer"
        target="_blank"
      >
        Create or manage an OpenRouter key
      </a>
      <div className="canvas-ai-form-actions">
        {assistant.hasCredential && (
          <button className="canvas-ai-button canvas-ai-button--danger" onClick={handleRemove} type="button">
            Remove key
          </button>
        )}
        {onCancel && (
          <button className="canvas-ai-button" onClick={onCancel} type="button">
            Back to chat
          </button>
        )}
        <ButtonComponent
          buttonName={assistant.isCredentialBusy ? "Checking…" : "Connect"}
          disabled={!apiKey.trim() || assistant.isCredentialBusy}
          size="compact"
          tone="actionSave"
          type="submit"
        />
      </div>
    </form>
  );
};

export default CanvasAiKeyForm;
